import React from 'react';
import { Typography } from '@mui/material';
import { statusBadgeSx, statusBarSx, statusLabelSx } from '../css/revenueItems.styles';
import { BATCH_STATUS_LABELS, isPendingDistributionBatch } from '../utils/revenueSharing.utils';

const STATUS_COLORS = {
  locked: '#3b82f6',
  executed: '#4caf50',
  cancelled: '#9aa4b2',
};

const BatchStatusBadge = ({ status }) => {
  const key = (status || '').toLowerCase();
  const labelKey = isPendingDistributionBatch(key) ? 'locked' : key;
  const color = STATUS_COLORS[labelKey] || '#9aa4b2';
  const label = BATCH_STATUS_LABELS[labelKey] || (key ? key.charAt(0).toUpperCase() + key.slice(1) : '—');

  return (
    <Typography component="span" sx={statusBadgeSx}>
      <Typography component="span" sx={{ ...statusBarSx, backgroundColor: color }} />
      <Typography component="span" sx={{ ...statusLabelSx, color }}>
        {label}
      </Typography>
    </Typography>
  );
};

export default BatchStatusBadge;
